export default __webpack_public_path__ + "static/media/chip-graphic.c1490ab9.svg";